import { createSlice } from '@reduxjs/toolkit';

const updateOrderCacheField = (field, data) => {
  let order = {};

  try {
    const cached = JSON.parse(localStorage.getItem('order'));
    order = cached || {};
  } catch (ex) {
    // ignore
  }
  order[field] = data;

  try {
    localStorage.setItem('order', JSON.stringify(order, null, 2));
  } catch (ex) {
    // ignore
  }
};

const getOrderCacheField = (field, def = {}) => {
  let order = {};

  try {
    const cached = JSON.parse(localStorage.getItem('order'));
    order = cached || {};
  } catch (ex) {
    // ignore
  }
  return order[field] || def;
};

const clearOrder = {
  quote: false,
  shopping_cart_id: null,
  shipping: {
    commited: false,
    data: {
      shipping_address_id: null,
    },
  },
  billing: {
    commited: false,
    data: {
      billing_address_id: null,
    },
  },
  payment: {
    commited: false,
    type: null,
    data: {
      po: null,
      po_number: null,
      payment_type: null,
      payment_method_id: null,
      reference_number: null,
    },
  },
  review: {
    commited: false,
    data: {
      tags: [],
      shipment_details: [],
    },
  },
};

export const getCheckoutOrder = (state) => {
  const order = state.cart.order;

  return {
    shopping_cart_id: order.shopping_cart_id,
    ...order.shipping.data,
    ...order.billing.data,
    ...order.payment.data,
    ...order.review.data,
  };
};

const initialState = {
  cart_id: localStorage.getItem('cart_id', null),

  // rewrite with cached data
  order: {
    quote: getOrderCacheField('quote', false),
    shopping_cart_id: getOrderCacheField('shopping_cart_id', null),
    shipping: {
      ...clearOrder.shipping,
      ...getOrderCacheField('shipping'),
      data: {
        ...clearOrder.shipping.data,
        ...getOrderCacheField('shipping')?.data,
      },
    },
    billing: {
      ...clearOrder.billing,
      ...getOrderCacheField('billing'),
      data: {
        ...clearOrder.billing.data,
        ...getOrderCacheField('billing')?.data,
      },
    },
    payment: {
      ...clearOrder.payment,
      ...getOrderCacheField('payment'),
      data: {
        ...clearOrder.payment.data,
        ...getOrderCacheField('payment')?.data,
      },
    },
    review: {
      ...clearOrder.review,
      ...getOrderCacheField('review'),
      data: {
        ...clearOrder.review.data,
        ...getOrderCacheField('review')?.data,
      },
    },
  },
};

const slice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    changeCart: (state, { payload: cart_id }) => {
      state.cart_id = cart_id;
      localStorage.setItem('cart_id', cart_id);
    },
    clearOrder: (state) => {
      state.order = clearOrder;
      localStorage.removeItem('order');
    },
    markOrderAsQuote: (state) => {
      updateOrderCacheField('quote', true);
      state.order.quote = true;
    },
    updateOrderShoppingCartId: (state, { payload }) => {
      updateOrderCacheField('shopping_cart_id', payload);
      state.order.shopping_cart_id = payload;
    },
    updateOrderShippingStepData: (state, { payload }) => {
      updateOrderCacheField('shipping', payload);
      state.order.shipping = payload;
    },
    updateOrderBillingStepData: (state, { payload }) => {
      updateOrderCacheField('billing', payload);
      state.order.billing = payload;
    },
    updateOrderPaymentStepData: (state, { payload }) => {
      updateOrderCacheField('payment', payload);
      state.order.payment = payload;
    },
  },
});

export default slice;
